// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_nt-0";
export var buttonContainer = "_nt-3";
export var cancelButton = "_nt-4";
export var headerSection = "_nt-6";
export var headerTitle = "_nt-9";
export var messageSideLeft = "_nt-1";
export var messageSideRight = "_nt-2";
export var orderNumberContainer = "_nt-7";
export var orderNumberLabel = "_nt-8";
export var submitButton = "_nt-5";